AoPS.Utils.initKeyChain(AoPS, "Contests", "Utils");

AoPS.Contests.Utils = (function (Utils) {
	Utils = _.extend({}, AoPS.Ecole.Utils);

	Utils.ajax_runner = new AoPS.Ajax.ScriptRunner(
		"/m/contests/ajax_landing.php",
		{
			use_queue: true,
			filter_interval: 0,
		}
	);

	Utils.ajax_admin_runner = new AoPS.Ajax.ScriptRunner(
		"/m/contests/ajax_admin.php",
		{
			use_queue: true,
			filter_interval: 0,
		}
	);

	Utils.ajax_contest_runner = new AoPS.Ajax.ScriptRunner(
		"/m/contests/ajax_contest.php",
		{
			use_queue: true,
			filter_interval: 0,
		}
	);

	Utils.ajax_flow_runner = new AoPS.Ajax.ScriptRunner(
		"/m/contests/ajax_flow.php",
		{
			use_queue: true,
			filter_interval: 0,
		}
	);

	Utils.ajax_accept_invitation_runner = new AoPS.Ajax.ScriptRunner(
		"/m/contests/ajax_accept_invitation.php",
		{
			use_queue: true,
			filter_interval: 0,
		}
	);

	Utils.ajax_portal_runner = new AoPS.Ajax.ScriptRunner(
		"/m/contests/ajax_portal.php",
		{
			use_queue: true,
			filter_interval: 0,
		}
	);

	Utils.ajax_special_register_runner = new AoPS.Ajax.ScriptRunner(
		"/m/contests/ajax_special_register.php",
		{
			use_queue: true,
			filter_interval: 0,
		}
	);

	Utils.ajax_special_manage_runner = new AoPS.Ajax.ScriptRunner(
		"/m/contests/ajax_special_manage.php",
		{
			use_queue: true,
			filter_interval: 0,
		}
	);

	// Flow runner for contest submission updates ONLY
	// to prevent infinite ajax loops
	Utils.ajax_flow_update_runner = new AoPS.Ajax.ScriptRunner(
		"/m/contests/ajax_flow.php",
		{
			use_queue: false,
			filter_interval: 0,
		}
	);

	// Just some cms things.
	Utils.cmsFileTypes = [
		{
			name: "Landing",
			prefix: "landing",
		},
		{
			name: "Portal",
			prefix: "portal",
		},
		{
			name: "Play",
			prefix: "play",
		},
		{
			name: "Review",
			prefix: "review_details",
		},
		{
			name: "Leaderboards",
			prefix: "leaderboards",
		},
		{
			name: "Grader",
			prefix: "grader",
		},
		{
			name: "Special Manage",
			prefix: "special_manage",
		},
		{
			name: "Special Register",
			prefix: "special_register",
		},
		{
			name: "Videos",
			prefix: "videos",
		},
	];

	Utils.createCmsTable = function (opt) {
		if (_.isFunction((opt || {}).loadCms) && opt.$table) {
			opt.loadCms({}, function (cms_files) {
				var $headTr = $("<tr />")
					.append($("<th />").text("Type").css("width", "140px"))
					.appendTo($("<thead />").appendTo(opt.$table.empty()));
				var $tbody = $("<tbody />").appendTo(opt.$table);

				var columns = [
					{
						name: "Contest (" + (opt.contestCmsHash || "") + ")",
						file: "contest_" + opt.contestCmsHash || "",
					},
					{
						name: "Flavor (" + (opt.flavorCmsHash || "") + ")",
						file: "flavor_" + opt.flavorCmsHash || "",
					},
					{
						name: "Default",
						file: "flavor_default",
					},
				];

				opt.$table.css("table-layout", "fixed");
				_.each(columns, function (column) {
					$headTr.append($("<th />").text(column.name));
				});

				_.each(Utils.cmsFileTypes, function (row) {
					var $tr = $("<tr />")
						.append($("<td />").text(row.name).css("width", "140px"))
						.appendTo($tbody);
					var datastore_git_branch =
						(AoPS.bootstrap_data || {}).datastore_git_branch || "master";
					var github =
						"//github.com/aops-ba/aopsdata/blob/" +
						datastore_git_branch +
						"/cms/contests";
					var github_new =
						"//github.com/aops-ba/aopsdata/new/" + datastore_git_branch;

					_.each(columns, function (column) {
						var file = row.prefix + "_" + column.file + ".handlebars";
						var found = _.findWhere(cms_files, {file: file});
						var $td = $("<td />").appendTo($tr);

						$td.append(
							$("<div />")
								.attr("title", file)
								.css({
									"max-width": "100%",
									"white-space": "nowrap",
									overflow: "hidden",
									"text-overflow": "ellipsis",
									"font-family": "monospace",
								})
								.text(file)
						);

						if (found) {
							$td.append(
								$("<div />")
									.css("text-align", "right")
									.append(
										$("<a />")
											.addClass("btn btn-primary")
											.text("VIEW")
											.click(function () {
												var loadingModal = Utils.CreateModalInescapable();
												opt.loadCms(
													{
														file: file,
													},
													function () {
														AoPS.Ui.Modal.removeModal(loadingModal);
														Utils.CreateModalAlert(
															$("<div />")
																.append(
																	$("<div />")
																		.css({
																			"font-size": "1.2em",
																			"font-weight": "bold",
																		})
																		.text("File: ")
																		.append(
																			$("<span />")
																				.css("font-family", "monospace")
																				.text(file)
																		)
																)
																.append(
																	$("<p />")
																		.css("max-width", "640px")
																		.text("Here is ")
																		.append(
																			$("<span />")
																				.css("font-family", "monospace")
																				.text(file)
																		)
																		.append(
																			" as it exists on the server currently. "
																		)
																		.append(
																			" If the contents of this file do not match "
																		)
																		.append(
																			$("<a />")
																				.attr({
																					href: github + "/" + file,
																					target: "_blank",
																				})
																				.append(
																					$("<b />").text("the file on GitHub")
																				)
																		)
																		.append(", please pull the latest ")
																		.append(
																			$("<span />")
																				.css("font-family", "monospace")
																				.text(
																					"aopsdata/" + datastore_git_branch
																				)
																		)
																		.append(" on this server.")
																)
																.append(
																	$("<textarea />")
																		.attr("readonly", "readonly")
																		.css({width: "640px", height: "480px"})
																		.val(found.text)
																)
														);
													},
													function () {
														AoPS.Ui.Modal.removeModal(loadingModal);
													}
												);
											})
									)
									.append(" ")
									.append(
										$("<a />")
											.attr({href: github + "/" + file, target: "_blank"})
											.addClass("btn btn-primary")
											.text("EDIT")
									)
							);
						} else {
							$td.append(
								$("<div />")
									.css("text-align", "right")
									.append(
										$("<a />")
											.attr({
												href: github_new + "?filename=cms/contests/" + file,
												target: "_blank",
											})
											.addClass("btn btn-success")
											.text("CREATE")
									)
							);
						}
					});
				});
				opt.$tbody;
			});
		}
	};

	/**
	 * Returns a string depending on whether the event is in the past, present, or future (day only)
	 * Can return false if event is missing required attributes
	 *
	 * @param {object} event A contest event
	 * @returns {string|false}
	 */
	Utils.placeEvent = function (event, current_date) {
		if (!("start_date" in event)) {
			console.error(
				"Property 'start_date' does not exist in the following object:"
			);
			console.error(event);
			return false;
		}
		if (!("end_date" in event) || !event.end_date) {
			// if no end_date, assume same as start_date
			event.end_date = event.start_date;
		}
		if (moment(event.start_date, "YYYY-MM-DD") > current_date) {
			return "upcoming";
		}
		if (moment(event.end_date, "YYYY-MM-DD") < current_date) {
			return "past";
		}
		return "current";
	};

	/**
	 * Determines what category an event should fall under (if at all), accounting for monthly categorization and type
	 *
	 * @param {object} event A contest event
	 * @param {string} type Contest hash to filter by
	 * @returns {object|false} Object with the new event added in the corresponding category
	 */
	Utils.getEventCategory = function (event, type = "") {
		if (
			type &&
			event.types &&
			!event.types.includes(type) &&
			!event.types.includes("all")
		) {
			// exit immediately if event is not of correct type
			return false;
		}

		var start_date = moment(event.start_date, "M/D/YY");
		var category = start_date.format("MMMM YYYY");
		return category;
	};

	/**
	 * Sorts, filters, and splits the events based on the contest portal type and date
	 *
	 * @param {array} events Array of events objects defined in /data-aops/cms/contests/objects/events.json
	 * @param {string} type Contest hash to filter by
	 */
	Utils.processEvents = function (events, type = "") {
		try {
			// sort events by start_date
			events.sort(function (event1, event2) {
				// assumes all dates are formatted the same way with descending significance (YYYY-MM-DD)
				if (event1.start_date < event2.start_date) {
					return -1;
				}
				if (event1.start_date > event2.start_date) {
					return 1;
				}
				return 0;
			});

			// set today's date (year/month/day *only*) as moment object
			var current_date = moment(moment().format("YYYYMMDD"), "YYYYMMDD");
			// split into upcoming and past events
			var upcoming = {};
			var past = {};
			_.each(events, function (event) {
				var place = Utils.placeEvent(event, current_date);
				if (place === false) {
					return;
				}

				event = Utils.styleEventDateTime(event);
				// if sticky or upcoming/current, keep on top
				if (place === "current" || ("sticky" in event && event.sticky)) {
					event.highlight = true;
				}

				var category = Utils.getEventCategory(event, type);
				if (category) {
					var bucket = // pass-by-reference
						place !== "past" || ("sticky" in event && event.sticky)
							? upcoming
							: past;
					if (category in bucket) {
						bucket[category].push(event);
					} else {
						bucket[category] = [event];
					}
				}
			});

			var processed = {
				upcoming_events: Object.keys(upcoming).length ? upcoming : false,
				past_events: Object.keys(past).length ? past : false,
			};

			return processed;
		} catch (e) {
			console.error(e);
		}

		return null;
	};

	/**
	 * Categorizes FAQs by their header
	 *
	 * @param {array} faqs Array of FAQ objects defined in /data-aops/cms/contests/objects/events.json
	 * @param {array}
	 */
	Utils.processFAQs = function (faqs) {
		var processed = {};

		_.each(faqs, (faq) => {
			if (faq.header in processed) {
				processed[faq.header].push(faq);
			} else {
				// start new category
				processed[faq.header] = [faq];
			}
		});

		return processed;
	};

	/**
	 * Stylizes dates and/or times for events to display
	 *
	 * @param {object} event A contest event
	 * @returns {object} The contest event with stylized datetime properties
	 */
	Utils.styleEventDateTime = function (event) {
		var start_date;
		var end_date;
		if ("show_time_range" in event && event.show_time_range) {
			// can assume event has start and end time
			start_date = moment(
				event.start_date + " " + event.start_time,
				"YYYY-MM-DD H:mm"
			);
			end_date = moment(
				("end_date" in event ? event.end_date : event.start_date) +
					" " +
					event.end_time,
				"YYYY-MM-DD H:mm"
			);
			event.start_time = start_date.format("h:mm A");
			event.end_time = end_date.format("h:mm A");
			event.end_date = end_date.format("M/D/YY");
		} else {
			if ("start_time" in event && event.start_time) {
				start_date = moment(
					event.start_date + " " + event.start_time,
					"YYYY-MM-DD H:mm"
				);
				event.time = start_date.format("h:mm A");
			} else {
				start_date = moment(event.start_date, "YYYY-MM-DD");
			}
			if ("end_date" in event && event.end_date) {
				end_date = moment(event.end_date, "YYYY-MM-DD");
				event.end_date = end_date.format("M/D/YY");
			} else {
				delete event.end_date;
			}
		}
		event.fancy_date = start_date.date();
		event.fancy_month = start_date.format("MMM");
		event.start_date = start_date.format("M/D/YY");
		// only show one date if starts/ends on same day
		if (event.start_date === event.end_date) {
			delete event.end_date;
		}
		return event;
	};

	Utils.setupLandingPage = function () {
		// really not sure why setTimeout makes this work
		setTimeout(function () {
			/*** EVENTS ***/
			// remove events-container titles if it is immediately preceded by an .additional class
			// aka. none of the events of that month should be initially displayed
			// note: this is here because the :has pseudo-class isn't supported by most browsers in CSS
			$(".events-container h3:has(+ .additional)").css("display", "none");

			// remove load-more buttons if there aren't any additional events to load
			if ($(".upcoming-events .additional").length === 0) {
				$("#load-more-upcoming").css("display", "none");
			}
			if ($(".past-events .additional").length === 0) {
				$("#load-more-past").css("display", "none");
			}

			// onclick events for the load more buttons
			$("#load-more-upcoming").click(function () {
				$("#load-more-upcoming").css("display", "none"); // hide self
				$(".upcoming-events .additional").css("display", "grid"); // load rest of events
				$(".upcoming-events .additional").css("display", "-ms-grid"); // IE version
				$(".upcoming-events h3").css("display", "block"); // show all titles
			});
			$("#load-more-past").click(function () {
				$("#load-more-past").css("display", "none"); // hide self
				$(".past-events .additional").css("display", "grid"); // load rest of events
				$(".past-events .additional").css("display", "-ms-grid"); // IE version
			});
		}, 0);
	};

	Utils.setFAQsEventListeners = function () {
		// really not sure why setTimeout makes this work
		setTimeout(function () {
			var faq_headers = $(".faq-card-header");
			var i;
			for (i = 0; i < faq_headers.length; i++) {
				faq_headers[i].addEventListener("click", function () {
					this.classList.toggle("active-faq");
					// hide/show panel
					var card_body = this.nextElementSibling;
					card_body.style.maxHeight = card_body.style.maxHeight
						? null
						: card_body.scrollHeight + "px";
				});
			}
		}, 0);
	};

	Utils.scrollTo = function (scrollTop) {
		// really not sure why setTimeout makes this work
		setTimeout(function () {
			if (window.location.hash) {
				var item = $(
					window.location.hash +
						", a[name='" +
						window.location.hash.slice(1) +
						"']"
				);
				if (item[0]) {
					item[0].scrollIntoView({behavior: "smooth", block: "start"});
				}
			} else if (scrollTop) {
				$(window).scrollTop(0);
			}
		}, 0);
	};

	Utils.formatTimeRemainingSec = function (num_seconds) {
		var num_seconds_disp = Math.max(num_seconds, 0);
		var disp_hr = Math.floor(num_seconds_disp / 60 / 60);
		var disp_min = Math.floor(num_seconds_disp / 60) % 60;
		var disp_sec = num_seconds_disp % 60;

		if (disp_hr > 0) {
			return (
				disp_hr +
				":" +
				("0" + disp_min).slice(-2) +
				":" +
				("0" + disp_sec).slice(-2)
			);
		}
		return disp_min + ":" + ("0" + disp_sec).slice(-2);
	};

	/**
	 * This method is kind of a render helper for portal event banners that are
	 * added to the page earlier -- for example, Contest.addEventBanner
	 *
	 * Because some contests are large enough to require staggered starts,
	 * not all countdowns are as simple as the official start time. Custom
	 * countdown banner parameters can be added to SPECIAL_COUNTDOWN_PARAMETERS.
	 *
	 * This is not used for F=ma at time of written since that one is not
	 * on a portal page.
	 *
	 * @param {object} terms
	 */
	Utils.setupEventBanner = function (terms) {
		var SPECIAL_COUNTDOWN_PARAMETERS = {
			// mathcounts-2020-2021-chapter-invitational
			14: {
				total_stagger_groups: 6,
				stagger_offset_ms: 120000, // 2 minutes
			},
			// mathcounts-2020-2021-state
			30: {
				total_stagger_groups: 3,
				stagger_offset_ms: 60000, // 1 minute
			},
			// aime-2020-2021-1
			32: {
				total_stagger_groups: 6,
				stagger_offset_ms: 60000, // 1 minute
			},
			// aime-2020-2021-2
			//33: {
			//	total_stagger_groups: 6,
			//	stagger_offset_ms: 60000, // 1 minute
			//},
			// mathcounts-2021-2022-state
			68: {
				total_stagger_groups: 6,
				stagger_offset_ms: 30000, // 30 seconds
			},
		};
		// really not sure why setTimeout makes this work
		setTimeout(function () {
			var $event_banner_countdown = $("#contest .event-banner-countdown");
			/* countdown timer */
			// code adapted from https://www.w3schools.com/howto/howto_js_countdown.asp
			if (!$event_banner_countdown.length) {
				return;
			}
			var $event_banner = $("#contest .event-banner");
			var contest_id = $event_banner.attr("data-contest-id");

			if (
				contest_id &&
				SPECIAL_COUNTDOWN_PARAMETERS.hasOwnProperty(contest_id)
			) {
				// Some contests need to support stagger starts in the portal,
				// such as MATHCOUNTS CI or AIME.
				Utils.initCountdownPortal(
					_.extend(SPECIAL_COUNTDOWN_PARAMETERS[contest_id], {
						terms,
						$event_banner,
						$event_banner_countdown,
					})
				);
				return;
			}

			let startTimeMoment;
			function setStart() {
				const sqlStartTime = $event_banner_countdown.attr(
					"data-countdown-time"
				);
				const startTime = sqlStartTime.replace(/-/g, "/");

				startTimeMoment = moment(startTime).tz("America/New_York");
			}
			setStart();

			var countdown = setInterval(function () {
				// setStart(); // Uncomment to debug
				var diff = startTimeMoment.diff(moment(), "seconds");

				if (diff <= 0) {
					clearInterval(countdown);
					$event_banner_countdown.text("00:00:00");
					setTimeout(function () {
						window.location.reload(true);
					}, 1200);
				} else {
					$event_banner_countdown.text(Utils.formatTimeRemainingSec(diff));
				}
			}, 1000);
		});
	};

	Utils.staggeredEventBanner = function (options) {};

	Utils.processSingleField = function (data, field) {
		var extra = {
			name_short: field.name_short || field.name,
			name_display: field.name_display || field.name,
			value: data[field.key] || "",
			display: data[field.key] || "",
		};

		if (field.type === "year") {
			// generate options for year input
			var years = field.years || 100;
			field.options = [
				{
					name: "Select Year",
					value: "",
				},
			];
			var curr_year = parseInt(moment().format("YYYY"));
			for (var year = curr_year; year > curr_year - years; year--) {
				field.options.push({
					name: year,
					value: year,
				});
			}
			field.type_is_dropdown = true;
		} else if (field.type === "month") {
			// generate options for month input
			field.options = [
				{
					name: "Select Month",
					value: "",
				},
			];
			for (var m = 1; m <= 12; m++) {
				var name = moment(m, "M").format("MMMM");
				field.options.push({
					name: name,
					value: m,
				});
			}
			field.type_is_dropdown = true;
		}

		if (field.options) {
			extra.options = _.map(field.options, function (option) {
				var output = {
					name: _.isObject(option) ? option.name : option,
					value: _.isObject(option) ? option.value : option,
				};
				output.display =
					_.isObject(option) && option.display ? option.display : output.name;
				output.selected =
					isNaN(output.value) || isNaN(extra.value)
						? output.value === extra.value
						: parseInt(output.value) === parseInt(extra.value);
				if (output.selected) {
					extra.display = output.display;
				}
				return output;
			});
		}
		if (field.depends_on) {
			extra.dependency_met = data[field.depends_on] === field.dependency_value;
			if (!extra.dependency_met) {
				extra.optional = true;
				extra.value = "";
				extra.display = "";
			}
			extra.hide_on_display = true;
		}
		extra["type_is_" + field.type] = true;
		return _.extend({}, field, extra);
	};

	Utils.processRegistrationForm = function (form, data = {}) {
		return _.map(form, function (group) {
			return _.extend({}, group, {
				fields: _.map(group.fields, function (field) {
					var output_field = Utils.processSingleField(data, field);
					if (output_field.dependent) {
						var dependent = _.findWhere(group.fields, {
							key: output_field.dependent,
						});
						if (dependent) {
							var processed = Utils.processSingleField(data, dependent);
							if (processed.dependency_met) {
								output_field.display += " – " + processed.display;
							}
							if (output_field.options) {
								output_field.options = _.map(
									output_field.options,
									function (option) {
										return _.extend(
											option.value === processed.dependency_value
												? {dependent_field: processed}
												: {},
											option
										);
									}
								);
							}
						}
					}
					return output_field;
				}),
			});
		});
	};

	Utils.fromUnderscoreOrHyphenToTitleCase = function (text) {
		return text.replace(/((^|[-_])[a-z])/gi, function ($1) {
			return $1.toUpperCase().replace("-", " ").replace("_", " ");
		});
	};

	Utils.fromTitleCaseToUnderscore = function (text) {
		return text
			.match(
				/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
			)
			.map((x) => x.toLowerCase())
			.join("_");
	};

	Utils.formFieldValidators = {
		Email: function (value) {
			return value.match(
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			);
		},
		MiddleInitial: function (value) {
			return value.match(/^[a-z]{0,2}$/i);
		},
		PhoneUSA: function (value) {
			return value.replace(/[^0-9a-z]/gi, "").match(/^[0-9]{10}$/i);
		},
		Phone: function (value) {
			return true;
		},
	};

	Utils.formFieldReplacers = {
		PhoneUSA: function (value) {
			var digits = value.replace(/[^0-9]/g, "");
			return (
				digits.slice(0, 3) + "-" + digits.slice(3, 6) + "-" + digits.slice(6)
			);
		},
	};

	/**
	 * Renders a text countdown to a jQuery element.
	 * Supports a callback function when zero is reached.
	 *
	 * @param {object} options
	 * @param {jQuery} options.$el
	 * 	The element to render the countdown to.
	 * @param {moment} options.target_moment
	 * 	The target moment object to count down to.
	 * @param {function} [options.on_complete]
	 * 	The function to call when we reach zero.
	 */
	Utils.renderCountdown = function (options) {
		function updateCountdown() {
			var $el = options.$el;
			var target_moment = options.target_moment;
			var on_complete = options.on_complete;

			var now_moment = moment();
			var time_until_start_ms = target_moment.diff(now_moment);

			if (time_until_start_ms <= 0) {
				clearInterval(countdown_interval);
				if (on_complete) {
					on_complete();
				}
				return;
			}

			var seconds_left = Math.floor(time_until_start_ms / 1000);
			var minutes_left = Math.floor(seconds_left / 60);
			var hours_left = Math.floor(minutes_left / 60);

			var seconds = (seconds_left % 60).toString().padStart(2, "0");
			var minutes = minutes_left
				? (minutes_left % 60).toString().padStart(2, "0") + ":"
				: "";
			var hours = hours_left
				? hours_left.toString().padStart(2, "0") + ":"
				: "";

			var countdown_fmt = hours + minutes + seconds;

			$el.text(countdown_fmt);
		}

		var countdown_interval = setInterval(updateCountdown, 1000);
		updateCountdown();
	};

	/**
	 * Computes and returns staggered start times for the F=ma.
	 * Returns null if time cannot be computed.
	 *
	 * @param {object} options
	 * @param {{data: {proctor_member_id: number}}} options.registration
	 * @param {boolean} options.official_individual_contest_has_ended
	 * @param {number} options.official_individual_contest_start_unix_time
	 * @returns {null | {
	 * 		ms_until_official_start: number,
	 * 		ms_until_staggered_start: number,
	 * 		stagger_group: number,
	 * 		staggered_start_moment: moment,
	 * }}
	 */
	Utils.getF_maStaggeredStartTime = function (options) {
		/** The number of groups/batches for stagger starts. */
		var TOTAL_STAGGER_GROUPS = 3;

		/** How many milliseconds between stagger groups. */
		var STAGGER_GROUP_OFFSET_MS = 30000; // 30 seconds

		// Get outta here if we can't or shouldn't initialize the countdown timer.
		if (
			!options.registration ||
			options.official_individual_contest_has_ended ||
			!options.official_individual_contest_start_unix_time
		) {
			return null;
		}

		// Determine what stagger group we're in using proctor ID or user ID.
		var proctor_member_id = parseInt(
			options.registration.data.proctor_member_id
		);
		var user_id = AoPS.session.user_id;
		var stagger_group =
			(proctor_member_id || user_id || 0) % TOTAL_STAGGER_GROUPS;

		// Compute the moment this stagger group starts.
		var official_start_moment = moment(
			options.official_individual_contest_start_unix_time
		);
		var staggered_start_moment = moment(
			options.official_individual_contest_start_unix_time
		).add(stagger_group * STAGGER_GROUP_OFFSET_MS, "ms");

		var now = moment();
		var ms_until_staggered_start = staggered_start_moment.diff(now, "ms");
		var ms_until_official_start = official_start_moment.diff(now, "ms");

		return {
			ms_until_official_start,
			ms_until_staggered_start,
			stagger_group,
			staggered_start_moment,
		};
	};

	/**
	 * Computes and returns staggered start times for the F=ma.
	 * Returns null if time cannot be computed.
	 *
	 * @param {object} options
	 * @param {{data: {proctor_member_id: number}}} options.registration
	 * @param {boolean} options.official_individual_contest_has_ended
	 * @param {number} options.official_individual_contest_start_unix_time
	 * @returns {null | {
	 * 		ms_until_official_start: number,
	 * 		ms_until_staggered_start: number,
	 * 		stagger_group: number,
	 * 		staggered_start_moment: moment,
	 * }}
	 */
	Utils.getUSABOSemifinalStaggeredStartTime = function (options) {
		/** The number of groups/batches for stagger starts. */
		var TOTAL_STAGGER_GROUPS = 3;

		/** How many milliseconds between stagger groups. */
		var STAGGER_GROUP_OFFSET_MS = 30000; // 30 seconds

		// Get outta here if we can't or shouldn't initialize the countdown timer.
		if (
			!options.registration ||
			options.official_individual_contest_has_ended ||
			!options.official_individual_contest_start_unix_time
		) {
			return null;
		}

		// Determine what stagger group we're in using registration unique ID or AoPS use rID
		var proctor_member_id = parseInt(options.registration.data.unique_id);
		var user_id = AoPS.session.user_id;
		var stagger_group =
			(proctor_member_id || user_id || 0) % TOTAL_STAGGER_GROUPS;

		// Compute the moment this stagger group starts.
		var official_start_moment = moment(
			options.official_individual_contest_start_unix_time
		);
		var staggered_start_moment = moment(
			options.official_individual_contest_start_unix_time
		).add(stagger_group * STAGGER_GROUP_OFFSET_MS, "ms");

		var now = moment();
		var ms_until_staggered_start = staggered_start_moment.diff(now, "ms");
		var ms_until_official_start = official_start_moment.diff(now, "ms");

		return {
			ms_until_official_start,
			ms_until_staggered_start,
			stagger_group,
			staggered_start_moment,
		};
	};

	/**
	 * This function initializes variables related to F=ma stagger starts
	 * by directly mutating `this.vars`.
	 * Please call after binding to an F=ma landing view or register view.
	 *
	 * @param {String} method_name
	 * @this {Views.ContestLandingContest | Views.ContestRegister}
	 * @example _.bind(initStaggerVars, this)();
	 * @example initStaggerVars.call(this);
	 */
	Utils.initStaggerVars = function (method_name) {
		/** How many minutes before contest start to enable countdown. */
		var COUNTDOWN_BUFFER_MS = 60 * 60 * 1000; // 60 minutes

		// Compute the stagger start time.
		var fn_name = `get${method_name}StaggeredStartTime`;
		if (typeof Utils[fn_name] !== "function") {
			return;
		}
		var stagger_data = Utils[fn_name](this.vars);
		if (!stagger_data) {
			return;
		}

		var {
			ms_until_official_start,
			ms_until_staggered_start,
			staggered_start_moment,
		} = stagger_data;

		// Set up this.vars for rendering countdown.
		if (
			ms_until_staggered_start > 0 &&
			ms_until_official_start <= COUNTDOWN_BUFFER_MS
		) {
			this.vars.official_individual_contest_has_started = false;
			this.vars.pre_start_countdown_active = true;
			this.vars.staggered_start_moment = staggered_start_moment;
		}
	};

	/**
	 * This function initializes the countdown timer for F=ma.
	 * Please call after binding to an F=ma landing view or register view.
	 *
	 * @this {Views.ContestLandingContest | Views.ContestRegister}
	 * @example _.bind(initCountdown, this)();
	 * @example initCountdown.call(this);
	 */
	Utils.initCountdown = function () {
		if (!this.vars.pre_start_countdown_active) {
			return;
		}

		var $pre_start_button = this.$(".pre-start .contest-start-button .btn");

		// Start the countdown render interval.
		var start_text = $pre_start_button.text();
		var countdown_options = {
			$el: $pre_start_button,
			target_moment: this.vars.staggered_start_moment,
			on_complete: function () {
				$pre_start_button.removeClass("disabled").text(start_text);
			},
		};

		AoPS.Contests.Utils.renderCountdown(countdown_options);
	};

	/**
	 * Computes and returns staggered start times.
	 * Returns null if time cannot be computed.
	 *
	 * @param {object} options
	 * @param {number} options.host_id
	 * @param {moment} options.start_moment
	 * @param {number} options.total_stagger_groups Number of batches
	 * @param {number} options.stagger_offset_ms Number of milliseconds between each batch
	 * @returns {null | {
	 * 		ms_until_official_start: number,
	 * 		ms_until_staggered_start: number,
	 * 		stagger_group: number,
	 * 		staggered_start_moment: moment,
	 * }}
	 */
	Utils.getStaggeredStartTime = function (options) {
		// Determine what stagger group we're in using host ID or user ID.
		var host_id = options.host_id;
		var user_id = AoPS.session.user_id;
		var stagger_group =
			(host_id || user_id || 0) % options.total_stagger_groups;

		// Compute the moment this stagger group starts.
		var start_moment = options.start_moment;
		var staggered_start_moment = start_moment
			.clone()
			.add(stagger_group * options.stagger_offset_ms, "ms");

		var now = moment();
		var ms_until_staggered_start = staggered_start_moment.diff(now, "ms");
		var ms_until_official_start = start_moment.diff(now, "ms");

		return {
			ms_until_official_start,
			ms_until_staggered_start,
			stagger_group,
			staggered_start_moment,
		};
	};

	/**
	 * This function initializes the countdown timer for staggered portal contests.
	 *
	 * @param {object} options
	 * @param {object} options.terms
	 * @param {number} options.total_stagger_groups Number of batches
	 * @param {number} options.stagger_offset_ms Number of milliseconds between each batch
	 * @param {jQuery} options.$event_banner
	 * @param {jQuery} options.$event_banner_countdown
	 */
	Utils.initCountdownPortal = function (options) {
		var $event_banner = options.$event_banner;
		var $event_banner_countdown = options.$event_banner_countdown;
		var $event_banner_text = $event_banner.find(".event-banner-text");
		var contest_name = $event_banner.attr("data-contest-name");
		var contest_term = options.terms.contest.lc || "competition";

		var start_time = $event_banner_countdown
			.attr("data-countdown-time")
			.replace(/-/g, "/");

		//We should put in a better fix later, but times are currently counting down to EST incorrectly when it's now EDT.
		start_time += " EDT";
		/*
		if (moment().isDST()) {
			// specify daylight time
			start_time += " EDT";
		} else {
			// specify standard time
			start_time += " EST";
		}
		*/

		var start_moment = moment(start_time);
		var host_id = $event_banner.attr("data-host-id");
		var has_exceptions = $event_banner_countdown.attr("data-has-exceptions");
		var {staggered_start_moment} = Utils.getStaggeredStartTime({
			start_moment,
			host_id,
			total_stagger_groups: options.total_stagger_groups,
			stagger_offset_ms: options.stagger_offset_ms,
		});

		var user_start_moment = has_exceptions
			? start_moment
			: staggered_start_moment;

		var user_start_fmt = user_start_moment
			.clone()
			.tz("America/New_York")
			.format("h:mma z");

		var $pre_start_button = $(
			`<a nav="1" class="btn btn-primary contest-start-button disabled"></a>`
		).appendTo($event_banner_text);

		$(`
			<p class="pre-start-description">
				Your ${contest_name} start time is ${user_start_fmt}.
				You can begin the ${
					contest_name || contest_term
				} by clicking on the button above once it automatically unlocks. There is no need to refresh the page.
				You may need to wait a few seconds for the ${contest_term} to load once you begin.
			</p>
		`).appendTo($event_banner_text);

		var countdown_options = {
			$el: $pre_start_button,
			target_moment: user_start_moment,
			on_complete: function () {
				var contest_hash = $event_banner.attr("data-contest-hash");
				var contest_term_capitalized =
					contest_term.slice(0, 1).toUpperCase() + contest_term.slice(1);

				$pre_start_button
					.removeClass("disabled")
					.text(`Start ${contest_term_capitalized}`)
					.attr("href", `/contests/${contest_hash}/individual`);
			},
		};

		AoPS.Contests.Utils.renderCountdown(countdown_options);
	};

	/**
	 * AoPS.Contests.Utils.processUrl does the same as ContestContest::processUrl
	 * Requires bootstrap of allUrlRoutes to equal the JSON decoded version of routes.json
	 */
	Utils.processUrl = function (url) {
		// The following processes the URL such that...
		// input: /contests/practice/amc-10-12/register/?why=1
		// becomes urlBody: "practice/amc-10-12/register"
		//     and qString: "?why=1"

		var matches =
			(url || "").match(/^\/*(contests\/+)?([^\?]*?)\/*(\?.*)?$/i) || [];
		var qString = matches[3] || "";
		var urlBody = matches[2] || "";

		// edge case when url = 'contests'
		urlBody = urlBody === "contests" ? "" : urlBody;

		var output = {
			urlBody: urlBody,
			qString: qString,
			route: "landing",
			routeMatch: "",
			routePreMatch: urlBody,
			routePostMatch: "",
			routePostArgs: [],
		};

		var allUrlRoutes = (AoPS.bootstrap_data || {}).allUrlRoutes || [];

		// We add slash to beginning and end so we can reliably match.
		var withLeadingAndTrailingSlash = `/${urlBody}/`;
		var shouldBreak = false;

		_.each(allUrlRoutes, function (route) {
			if (shouldBreak) {
				return;
			}

			_.each(route.url, function (urlMatch) {
				if (shouldBreak) {
					return;
				}

				var pos = withLeadingAndTrailingSlash
					.toLowerCase()
					.indexOf(`/${urlMatch}/`.toLowerCase());
				var mustStartWith = _.isUndefined(route.mustStartWith)
					? false
					: route.mustStartWith;
				var mustNotStartWith = _.isUndefined(route.mustNotStartWith)
					? false
					: route.mustNotStartWith;

				if ((!mustNotStartWith && pos === 0) || (!mustStartWith && pos > 0)) {
					output.route = route.route;
					output.routePreMatch = urlBody.substring(0, Math.max(0, pos - 1));
					output.routeMatch = urlMatch;
					output.routePostMatch = urlBody.substring(pos + urlMatch.length + 1);
					output.routePostArgs =
						output.routePostMatch === ""
							? []
							: output.routePostMatch.split("/");

					shouldBreak = true;
				}
			});
		});

		return output;
	};

	return Utils;
})(AoPS.Contests.Utils);
